import {useRef, useEffect, useLayoutEffect, useState } from "react";
import SecondLayer from "./SecondLayer";
import ScrollContainer from 'react-indiana-drag-scroll'
import { NavigationNotice } from "../assets/NavigationNotice/NavigationNotice";
import { MapPrivate } from "./Maps/MapPrivate";
import { MapBusiness } from "./Maps/MapBusiness";
import {Popup} from "../assets/popup/popup";
import { Status } from "../assets/Switch/Switch";
import "./Overworld.scss";
import { useWindowWidth } from "../useWindowWidth";
import { useMap } from './Maps/useMap'

//Dies ist die Hauptdatei

export const modules = {
  HAUSANSCHLUSS: "Hausanschluss",
  HAUSANSCHLUSSBUSINESS: "HausanschlussBusiness",
  ERZEUGUNGSANLAGEN: "Erzeugungsanlagen",
  ERZEUGUNGSANLAGENBUSINESS: "ErzeugungsanlagenBusiness",
  RECHTUNDTECHNIK: "RechtUndTechnik",
  OVERWORLD: ""
};

export const popups = {
  ELEKTROMOBILITAET: "Elektromobilitaet",
  ELEKTROMOBILITAETBUSINESS: "Elektromobilitaet_business",
  NETZAUSKUNFT: "Netzauskunft",
  NETZAUSKUNFTBUSINESS: "Netzauskunft_business",
  ZAEHLER: "Zaehler",
  ONLINESERVICES: "OnlineServices",
  HAUPTINSEL: "Hauptinsel",
  CLOSED: "Closed"
};


//Im oberen Teil der overworld-Funktion findet man hauptsächlich States, die zur Navigation notwendig sind. Auch speichert die Anwendung hier, welche Fensterbreite gerade aktiv ist.
//Im mittleren Teil, befindet sich eine switch/case Abfrage, die bestimmt ob und welches Popup geöffnet wird
//Im unteren Teil befindet sich die HTML-Struktur

export function Overworld(props: {text: any}) {
  //Text kommt durch fetchJSON.ts vom Portal
  const text: any = props.text;

  //Ruft die Umgebungsvariable um zu entscheiden welche GNO-Version benutzt wird
  const mapVersion = useMap();

  //Speichert die aktuelle Navigationsebene oder ob ein Popup offen ist
  const [route, setRoute] = useState(modules.OVERWORLD);
  const [popupRoute , setPopupRoute] = useState(popups.CLOSED)

  //initiales Popup wird überschrieben, wenn Nutzer ein Popup öffnet
  const [popup, setPopup] = useState(
    <Popup
      popupClass = "gno-invisible"
      headline="Beispieltext"
      text="Beispieltext!"
      buttonText="mehr erfahren"
      buttonFunction={() => {}}
      buttonClose={() => {
        setPopupRoute(popups.CLOSED);
      }}
      contentPopup = {true}
    ><p>Hallo</p></Popup>
  )

  //Bildschirmbreite wird durch CustomHook: useWindowWidth ermittelt
  const screenWidth = useWindowWidth();

  //dragged der Nutzer?
  const [isDragging, setIsDragging] = useState(false)

  //speichert ob Desktop
  const [desktop, setDesktop] = useState(false);

  const draggableContainer: any = useRef();

  //Scroll-Werte
  const [xValue, setXvalue] = useState(0);
  const [yValue, setYvalue] = useState(0);

  //const [allowDrag, setAllowDrag] = useState(false);

  //Hier werden die verscheidenen Fenstergrößen definiert und abhänig davon der Mittelpunkt der GNO, auf diese übertragen.
  //Dies ist ein "automatischer" Scroll 

  useLayoutEffect(() => {

    if(draggableContainer.current) {
      if (screenWidth <= 298) {
        setXvalue(200);
        setYvalue(100)
      } else if (screenWidth <= 350) {
        setXvalue(180);
        setYvalue(100)
      } else if (screenWidth <= 396) {
        setXvalue(223);
        setYvalue(160)
      } else if (screenWidth<= 435) {
        setXvalue(180);
        setYvalue(60)
      } else if (screenWidth <= 520) {
        setXvalue(200);
        setYvalue(120)
      } else if (screenWidth <= 600) {
        setXvalue(140);
        setYvalue(70)
      } else if (screenWidth <= 695) {
        setXvalue(150);
        setYvalue(70)
      }

      if(route === modules.OVERWORLD && window.innerWidth <= 695){
        draggableContainer.current.scrollTo(xValue, yValue)
      }
    }

    if (screenWidth < 695) {
      setDesktop(false)
    }
    else {
      setDesktop(true)
    }
    
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenWidth, route, desktop, xValue, yValue]);

  // Welches Popup wird gerendert:
  useEffect (() => {
    let isMounted = true;

    if(isMounted){

      switch(popupRoute) {
        case popups.ELEKTROMOBILITAET:
          setPopup(<Popup
            popupClass="popupPosition"
            headline={text.Overworld.Elektromobilitaet.headline}
            text={text.Overworld.Elektromobilitaet.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Elektromobilitaet.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          ></Popup>)
        break;
        case popups.ELEKTROMOBILITAETBUSINESS:
          setPopup(<Popup
            popupClass="popupPosition"
            headline={text.Overworld.Elektromobilitaet_business.headline}
            text={text.Overworld.Elektromobilitaet_business.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Elektromobilitaet_business.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          ></Popup>)
        break;
        case popups.NETZAUSKUNFT:
          setPopup(<Popup
            popupClass="popupPosition"
            headline={text.Overworld.Netzauskunft.headline}
            text={text.Overworld.Netzauskunft.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Netzauskunft.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          ></Popup>)
        break;
        case popups.NETZAUSKUNFTBUSINESS:
          setPopup(<Popup
            popupClass="popupPosition"
            headline={text.Overworld.Netzauskunft_business.headline}
            text={text.Overworld.Netzauskunft_business.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Netzauskunft_business.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          ></Popup>)
        break;
        case popups.ZAEHLER:
          setPopup( <Popup
            popupClass="popupPosition"
            headline={text.Overworld.Zaehler.headline}
            text={text.Overworld.Zaehler.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Zaehler.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          />)
        break;
        case popups.ONLINESERVICES:
          setPopup(<Popup
            popupClass="popupPosition"
            headline={text.Overworld.OnlineServices.headline}
            text={text.Overworld.OnlineServices.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.OnlineServices.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          ></Popup>)
        break;
        case popups.HAUPTINSEL:
          setPopup( <Popup
            popupClass="popupPosition"
            headline={text.Overworld.Hauptinsel.headline}
            text={text.Overworld.Hauptinsel.text}
            buttonText="Mehr erfahren"
            buttonFunction={() => {window.open(text.Overworld.Hauptinsel.link,'_self')}}
            buttonClose={() => {
              setPopupRoute(popups.CLOSED);
            }}
            contentPopup = {false}
          />)
        break;
        case popups.CLOSED:
          setPopup(<div></div>)
        }
      }
      return () => {isMounted=false}
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [popupRoute, text]);

    //Auswahl welche Karte gerendert werden soll
    function mapPick() {
      if(mapVersion === 'private'){
        return (<MapPrivate
          switchToModule={(module: any) => {
            if (!isDragging) {setRoute(module);}}}

          openPopup={(popup: any) => {
            if (!isDragging) {setPopupRoute(popup);}}}
        ></MapPrivate>)
      } 
      else if (mapVersion === 'business'){
        return (<MapBusiness
          switchToModule={(module: any) => {
            if (!isDragging) {setRoute(module);}}}

          openPopup={(popup: any) => {
            if (!isDragging) {setPopupRoute(popup);}}}
        ></MapBusiness>)
      }
    } 

  switch (route) {
    case modules.ERZEUGUNGSANLAGEN:
      //Nutzer klickt auf Erzeugungsanlagen Insel:
      return (
        <SecondLayer
          onBackNavigation={() => setRoute(modules.OVERWORLD)}
          text = {text}
          desktop = {desktop}
          layer = {modules.ERZEUGUNGSANLAGEN}
          count = {3}
          formulareIsActive = {true}
        />
      );
      case modules.ERZEUGUNGSANLAGENBUSINESS:
        //Nutzer klickt auf Erzeugungsanlagen Insel:
        return (
          <SecondLayer
            onBackNavigation={() => setRoute(modules.OVERWORLD)}
            text = {text}
            desktop = {desktop}
            layer = {modules.ERZEUGUNGSANLAGENBUSINESS}
            count = {3}
            formulareIsActive = {true}
            thirdButton = {false}
          />
        );
    case modules.HAUSANSCHLUSS:
      //Nutzer klickt auf Hausanschluss Insel:
      return (
        <SecondLayer
          onBackNavigation={() => setRoute(modules.OVERWORLD)}
          text = {text}
          desktop = {desktop}
          layer = {modules.HAUSANSCHLUSS}
          count = {3}
          formulareIsActive = {true}
        />
      );
      case modules.HAUSANSCHLUSSBUSINESS:
      //Nutzer klickt auf HausanschlussBusiness Insel:
      return (
        <SecondLayer
          onBackNavigation={() => setRoute(modules.OVERWORLD)}
          text = {text}
          desktop = {desktop}
          layer = {modules.HAUSANSCHLUSSBUSINESS}
          count = {3}
          formulareIsActive = {true}
        />
      );
      case modules.RECHTUNDTECHNIK:
      //Nutzer klickt auf Recht und Technik Insel:
      return (
        <SecondLayer
          onBackNavigation={() => setRoute(modules.OVERWORLD)}
          text = {text}
          desktop = {desktop}
          layer = {modules.RECHTUNDTECHNIK}
          count = {2}
          formulareIsActive = {false}
        />
      );
    default:
      //Overworld-JSX:
      return <div className="gno-overworld" data-testid="gno-desktop">
            {<Status page="Startseite" lable = {mapVersion === "business" ? "Für Unternehmen" : "Für Zuhause"}/>}
            <NavigationNotice isDragging = {isDragging}/>
            <ScrollContainer
            vertical={!desktop}
            horizontal={!desktop}
            className = "gno-scroll-container"
            innerRef= {draggableContainer}
            hideScrollbars={true}
            onStartScroll={() => setIsDragging(true)}
            onScroll={() => setIsDragging(true)}
            onEndScroll= {() => setIsDragging(false)}
            >
              <div className="gno-map">
                {mapPick()}
              </div>
            </ScrollContainer>
            {/*<Switch version= {mapVersion}/>*/}
          {popup}
        </div>  
  }
}
